import { Box, Grid, GridItem, Icon, Text } from '@chakra-ui/react';
import { useRouteError } from 'react-router-dom';

import Header from '../components/Header';
import { Warning } from '../components/svgs/Warning';

export const GenericErrorPage = () => {
  const error = useRouteError();

  // eslint-disable-next-line
  console.error(error);

  return (
    <>
      <Header />
      <Grid
        width="100%"
        height="100%"
        minHeight="60vh"
        alignItems="center"
        justifyItems="center"
      >
        <GridItem>
          <Box maxWidth="600px" textAlign="center">
            <Icon as={Warning} color="white" width="20" height="20" />
            <Text
              textStyle="h1"
              as="h1"
              mb="10"
              mt={{ base: '52px', md: '40px' }}
              fontWeight="bold"
            >
              Error
            </Text>
            <Text>Please contact support</Text>
          </Box>
        </GridItem>
      </Grid>
    </>
  );
};
